export const getReportsInitialState = {
  error: {},
  data: {},
  selectedReport:{},
  loadingSelectedReport: false,
  loading: false,
};
